import { render } from "./ListeFiliere.vue?vue&type=template&id=7272335e&ts=true"
import script from "./ListeFiliere.vue?vue&type=script&lang=ts"
export * from "./ListeFiliere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__